import moment from "moment";
import { getCookie } from "./session";

export const getFsoId = () => {
  const id = getCookie("fsoId");
  return id;
};

function generateRandomID(length = 6) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  return result;
}

export const getUserData = () => {
  const name = getCookie("userData");
  return name && name !== "undefined" && JSON.parse(name);
};

export const getNameFirstLetter = (name = "", letercount = 2) => {
  let latter = "";
  let i = 0;
  while (i < letercount) {
    latter += name?.[i]?.toUpperCase() || "";
    i++;
  }
  return latter;
};

export const formateDate = (date) => {
  return date ? moment(date).format("DD-MM-YYYY") : "";
};

export const formateNumber = (n) => {
  return n < 1 || n > 9 ? "" + n : "0" + n;
};

export const getFileName = (name) => {
  return name?.split(".")?.[0];
};

export const convertToBlob = (blob) => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      var base64data = reader.result;
      resolve(base64data?.split(",")?.[1]);
    };
  });
};

export const numberFormat = (value) => {
  const val = new Intl.NumberFormat("en-IN", {
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  return val;
};

export const getFormatedData = (type, data) => {
  switch (type) {
    case "date":
      return formateDate(data);
    case "percentage":
      return data ? data + "%" : "0%";
    case "currency":
      return data ? "INR " + numberFormat(data) : "INR 0";
    case "number":
      return data ? formateNumber(data) : "0";
    case "boolean":
      return data ? "Yes" : "No";
    default:
      return data || "";
  }
};
export const buildColumns = (columns) => {
  return columns?.map((column, index) => {
    return {
      id: generateRandomID(),
      header: column?.fieldLabel ? column?.fieldLabel : "",
      accessorKey: column?.fieldName ? column?.fieldName : "",
      cell: (row) => {
        return getFormatedData(column?.fieldType, row?.getValue(column.id));
      },
      ...column,
    };
  });
};

// date,  percentage,  string, number,  currency

export const calculateGST = (amount) => {
  const gst = amount / 100;

  return gst;
};

export const getFileType = (file) => {
  const fileExtension = getFileExtension(file);
  if (fileExtension?.toLocaleLowerCase() === "pdf") {
    return 1;
  } else {
    return 2;
  }
};

export const getFileExtension = (file = "") => {
  const splitPath = file?.split(".");
  return splitPath?.[splitPath?.length - 1];
};

export const downloadFile = (url, fileName) => {
  fetch(url)
    .then((resp) => resp.blob())
    .then((blob) => {
      this.downloadFileFormObj(blob, fileName);
      // or you know, something with better UX...
    })
    .catch((e) => {});
};
